import StoryLike from 'assets/SVG/StoryLike'
import StoryMute from 'assets/SVG/StoryMute'
import StoryPause from 'assets/SVG/StoryPause'
import StoryPlay from 'assets/SVG/StoryPlay'
import StoryUnmute from 'assets/SVG/StoryUnmute'

const ControlsBtn = ({ id, liked, likes, togglePlayPause, toggleMute, playingMap, index, temporaryLiked, handleLike, mutedMap }) => {
    return (
        <div className="reels-controls">
            <div className='likeBtn'>
                <button
                    disabled={liked || temporaryLiked}
                    className={`StoriesControlButtons ${liked || temporaryLiked ? "activeLike" : ""}`}
                    onClick={() => handleLike(id, index, likes)}
                >
                    <StoryLike className='StoryIcon' />
                </button>
            </div>

            <button aria-label="mute video" className='StoriesControlButtons' onClick={() => toggleMute(id)}>
                {!mutedMap[id] ? <StoryUnmute className={'StoryIcon'} /> : <StoryMute className={'StoryIcon'} />}
            </button>

            <button aria-label="play video"
                className='StoriesControlButtons'
                onClick={() => togglePlayPause(id)}>
                {playingMap[id] ? <StoryPause className='StoryIcon' /> : <StoryPlay className='StoryIcon' />}
            </button>
        </div>
    )
}

export default ControlsBtn